import type KinToastGroup from '@kin/web-components/dist/external/kin-toast-group/kin-toast-group.js';
import type KinToast from '@kin/web-components/dist/external/kin-toast/kin-toast.js';

// Clear all Toasts before Turbo caches the page. This prevents them from
// flickering briefly back into view when returning to the page.
// ShowToast elements must also be removed, otherwise they re-fire Toast.show()
// via connectedCallback when the cached page is later restored.
document.addEventListener('turbo:before-cache', () => {
  document
    .querySelector('kin-toast-group')
    ?.querySelectorAll('kin-toast')
    .forEach((toast: KinToast) => toast.hide());
  document.querySelectorAll('show-toast').forEach((el) => el.remove());
});

// Convenience functions for showing different variants of toasts within
// the toast group that is on the page.
class Toast {
  static show(
    content: string,
    variant: KinToast['variant'] = 'info',
    duration: number = 5000
  ): void {
    const group = document.querySelector('kin-toast-group') as KinToastGroup;
    if (group) {
      group.addToast(content, variant, duration);
    } else {
      console.warn('kin-toast-group not found in DOM');
    }
  }

  static success(message: string, duration: number = 5000): void {
    this.show(message, 'success', duration);
  }

  static info(message: string, duration: number = 5000): void {
    this.show(message, 'info', duration);
  }

  static error(message: string, duration: number = 5000): void {
    this.show(message, 'error', duration);
  }

  static warning(message: string, duration: number = 5000): void {
    this.show(message, 'warning', duration);
  }
}

export default Toast;
